module.exports = __webpack_public_path__ + "static/img/live_wechat03.1c7a172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live_wechat03.png
// module id = /D4l
// module chunks = 1